"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var carImageStyles = styles_1.makeStyles(function () { return ({
    image: {
        width: '100%',
        maxWidth: '500px',
        margin: '0 auto',
        display: 'block',
    },
}); }, { name: 'Summary_CarImage' });
exports.default = carImageStyles;
